"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useFormValidation = void 0;
var _zod = require("zod");
const useFormValidation = (param)=>{
    let { concernFormData, concernFormConfig } = param;
    const textFieldValidationSchema = (fieldCharacterLimit)=>_zod.z.string().trim().max(fieldCharacterLimit, {
            message: "".concat(concernFormData.tooManyCharactersMaximumIs, " ").concat(fieldCharacterLimit)
        });
    const textAreaFieldInputSchema = textFieldValidationSchema(concernFormConfig.characterLimitForATextArea);
    const textFieldInputSchema = textFieldValidationSchema(concernFormConfig.characterLimitForATextField);
    const validationSchema = _zod.z.object({
        textAreaFieldInput1: textAreaFieldInputSchema.min(1, {
            message: concernFormData.questionRequired
        }),
        textAreaFieldInput2: textAreaFieldInputSchema.min(1, {
            message: concernFormData.questionRequired
        }),
        textAreaFieldInput3: textAreaFieldInputSchema.min(1, {
            message: concernFormData.questionRequired
        }),
        radioButtonFieldInput4: _zod.z.string().trim().min(1, {
            message: concernFormData.questionRequired
        }),
        radioButtonFieldInput5: _zod.z.string().trim().min(1, {
            message: concernFormData.questionRequired
        }),
        radioButtonFieldInput6: _zod.z.string().trim().min(1, {
            message: concernFormData.questionRequired
        }),
        textFieldInput7: textFieldInputSchema.optional(),
        textAreaFieldInput9: textAreaFieldInputSchema.optional(),
        recaptcha: concernFormConfig.recaptchaEnabled ? _zod.z.string().min(1, {
            message: concernFormData.questionRequired
        }) : _zod.z.string().optional()
    });
    return {
        validationSchema
    };
};
exports.useFormValidation = useFormValidation;
